import { AlertProps } from '@ahc-digital/component-library';
import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';

export type A1AlertsProps = RenderingProps<A1AlertsFields, A1AlertsParams> & {
  /** This is set on the server side based on whether a cookie is detected. */
  dismissedAlerts?: string[];
};

export type A1AlertsFields = {
  alerts?: {
    value?: CombinedAlertProps[];
  };
};

export type CombinedAlertProps = AlertProps & {
  dismissPeriod?: string;
  uid?: string;
  primaryAlertText?: string;
  expandedAlertText?: string;
  mobileAlertText?: string;
};

export type A1AlertsParams = DynamicPlaceholderParams &
  AnchorTargetParams &
  TranslationOptionsParams;
